export default "__VITE_ASSET__UWOx6zGz__"